import { Apollo } from "apollo-angular";
import { firstValueFrom } from "rxjs";

import { Injectable, inject } from "@angular/core";

import { NotificationType } from "../apis/networkdashboard/graphql/graphql";
import { CimQueryImpactTypes, CimQueryStatuses, CimResult } from "../apis/networkdashboard/static/custom-types";
import { CIM_QUERY } from "../apis/networkdashboard/static/graphql-queries/cim-notifications";

@Injectable({ providedIn: "root" })
export class ServiceDisruptionService {
  private apollo = inject(Apollo);

  async fetchForSubscriptions(subscriptionIds: string[]): Promise<NotificationType[]> {
    const impacts = [
      CimQueryImpactTypes.DOWN,
      CimQueryImpactTypes.REDUCED_REDUNDANCY,
      CimQueryImpactTypes.RESILIENCE_LOSS,
    ];

    try {
      const result = await firstValueFrom(
        this.apollo.query<CimResult>({
          query: CIM_QUERY,
          variables: {
            includeAffectedSubscriptions: true,
            filter: {
              subscriptionIds,
              impacts,
              statuses: [CimQueryStatuses.OPEN, CimQueryStatuses.UPDATED],
            },
          },
        }),
      );
      return result.data?.notifications ?? [];
    } catch (error) {
      console.error("Error loading service disruption notifications:", error);
      return [];
    }
  }
}
